import Footer from "../Footer";
import Header from "../Header";
import transformLives from "../../img/transform-lives.png";
import childHelp from "../../img/child-help.png";
import VolunteersChild from "../../img/Volunteers-child.png";
import supporters from "../../img/supporters.png";
import Successfully from "../../img/Successfully.png";
import SwiperSection from "../HomePageComponents/SwiperSection";


const About = () => {
    return (
        <>
            <Header />
            <section className="about-us-main become-banner ">
                <div className="container">
                    <div className="banner-main-abt">
                        <div className="about-banner-content">
                            <h1 className="about-title-banner">About Us</h1>
                            <h3 className="page-active-main"><a href="/"><span className="active-page">Home</span></a>/About Us</h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className="transfer-live-main">
                <div className="container">
                    <div className="transfer-main-flex">
                        <div className="we-live-image">
                            <img src={transformLives} alt="transform-lives" />
                        </div>
                        <div className="we-live-content">
                            <h3 className="live-title-c">who we are</h3>
                            <h2 className="we-title">We Transform Lives</h2>
                            <p className="transform-content">Suspendisse sollicitudin velit sed leo. Ut pharetra augue nec augue. Nam elit agna,endrerit sit amet, tincidunt ac, viverra sed, nulla. Donec porta diam eu massa. Quisque diam lorem, interdum vitae,dapibus ac, scelerisque vitae, pede.  </p>
                            <p className="transform-content">Donec eget tellus non erat lacinia fermentum. Donec in velit vel ipsum auctor pulvinar. Vestibulum iaculis lacinia est. Proin dictum elementum velit. Fusce euismod consequat ante. Lorem ipsum dolor sit amet, consectetuer adipis. Mauris accumsan nulla vel diam. </p>
                            <a href="/" className="more-about ">Find Out More</a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="overview-child-help">
                <div className="container">
                    <div className="overview-child-flex">

                        <div className="child-bx-flex">
                            <div className="child-bx-img">
                                <img src={childHelp} alt="child-help" />
                            </div>
                            <div className="child-bx-ct">
                                <h2 className="child-title">24 M</h2>
                                <p className="child-ct">Children helped across our global movement</p>
                            </div>
                        </div>


                        <div className="child-bx-flex">
                            <div className="child-bx-img">
                                <img src={VolunteersChild} alt="child-help" />
                            </div>
                            <div className="child-bx-ct">
                                <h2 className="child-title">1.5 M</h2>
                                <p className="child-ct">Volunteers worldwidesupported our cause</p>
                            </div>
                        </div>

                        <div className="child-bx-flex">
                            <div className="child-bx-img">
                                <img src={supporters} alt="child-help" />
                            </div>
                            <div className="child-bx-ct">
                                <h2 className="child-title">16 M</h2>
                                <p className="child-ct">Raised by us and our supporters</p>
                            </div>
                        </div>

                        <div className="child-bx-flex">
                            <div className="child-bx-img">
                                <img src={Successfully} alt="child-help" />
                            </div>
                            <div className="child-bx-ct">
                                <h2 className="child-title">200</h2>
                                <p className="child-ct">Successfully projects completed</p>
                            </div>
                        </div>

                    </div>
                </div>

            </section>


            <section className="organisation-section-main">
                <div className="container">
                    <div className="our-org-top">
                        <h2 className="org-title">Our Organisation</h2>
                        <p className="org-p">Sharksucker sea toad candiru rocket danio tilefish stingray deepwater stingray Sacramento splittail, Canthigaster rostrata. Midshipman dartfish Modoc sucker, yellowtail kingfish</p>
                    </div>
                </div>
                <SwiperSection />
            </section>



            <section className="become-Vol-main">
                <div className="become-banner">
                    <div className="becomne-vol-content">
                        <h2 className="become-title">Make a Difference, Become a Volunteer!</h2>
                        <p className="become-cont">Join us to make a direct impact in the lives of the world’s most vulnerable children.</p>
                        <div className="btn-involved"> <a href="home.html">Get Involved</a></div>
                    </div>
                </div>

            </section>
            <Footer />
        </>
    )
}
export default About;
